import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import DeviceStore from '../stores/device_store';

const styles = StyleSheet.create({
  deviceSelect: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  spinner: { margin: '1rem', width: '2rem', height: '2rem' },
});

type Props = {
  style?: any;
  orgId: number;
  excludeList?: any;
  value: any;
  onChange: any;
  placeholder?: any;
  hideDisabled?: boolean;
};
export default function DeviceSelect(props: Props) {
  const { style, excludeList, value, onChange, orgId, hideDisabled, ...other } =
    props;
  const list = DeviceStore.useList(orgId);
  React.useEffect(() => {
    DeviceStore.fetch(orgId);
  }, [orgId]);

  function _onChange(new_value) {
    onChange(parseInt(new_value));
  }

  let content: any = null;
  if (!list) {
    content = <ProgressSpinner />;
  } else {
    const valid_list = list.filter((device) => {
      const { device_id, is_disabled } = device;
      let ret = !hideDisabled || !is_disabled;
      const excluded = excludeList?.find?.((v) => v.device_id === device_id);
      if (excluded) {
        ret = false;
      }
      return ret;
    });

    const options = [
      ...valid_list.map((d) => ({ value: d.device_id, text: d.device_name })),
    ];

    content = (
      <Select
        style={[styles.deviceSelect, style]}
        options={options}
        value={value}
        onChange={_onChange}
        {...other}
      />
    );
  }
  return content;
}
